import { cn } from '@/lib/cn';
import { getRelationFieldNames } from '@/requests/instanceMapper';
import {
  InspectionErrandFaultConfig,
  type InspectionErrandFault,
} from '@pigello/pigello-matrix';
import type { RelationFieldProps } from './types';
import Dot from './dot';

export const InspectionErrandFaultItem: RelationFieldProps<InspectionErrandFault> =
  {
    nested: getRelationFieldNames(InspectionErrandFaultConfig),
    filters: [],
    renderItem: (item, isRelationField) => ({
      title: item.description as string,
      descriptionItems: (
        <div
          className={cn(
            'flex w-full items-center',
            isRelationField && 'justify-between'
          )}
        >
          <span className='font-medium'>{item?.inspectionErrand?.title}</span>
          {!isRelationField && <Dot />}
          <span>{item?.customId ?? 'Inget objekts-id angivet'}</span>
        </div>
      ),
    }),
  };
